import { appraisalThirdPartyAvailable } from "configs/proposedProject.config";
import { DatePicker, FilePicker, Input, Textarea } from "stories";
import { RadioGroupList } from "stories/components/radioGroup/RadioGroup";
import { currencyStyle } from "utils/customHooks/currencyFormat";
import { ConditionalFormRenderer } from "../../../../../../../stories/components/FormRenderer/ConditionalFormRenderer";

const constructionFields = [
  [
    {
      name: "third_party_appraisal",
      component: RadioGroupList,
      props: {
        list: appraisalThirdPartyAvailable,
        label: "Third Party Appraisal Availability",
      },
    },
    {},
  ],
  [
    {
      renderAsFormItem: false,
      component: ConditionalFormRenderer,
      props: {
        conditionFieldName: "third_party_appraisal",
        cacheable: true,
        getDefaultValues: () => ({
          appraised_as_complete_value_of_property: "",
          appraised_cost_to_complete: "",
          appraised_residual_land_value: "",
          appraised_value_of_property: "",
          appraiser_description: "",
          appraiser_name: "",
          appraiser_report_date: null,
          appraiser_report_filename: null,
          estimated_value_of_property: "",
          total_appraised_value_of_property: "",
        }),
        conditionalFields: {
          false: [
            [
              {
                name: "estimated_value_of_property",
                component: Input,
                props: {
                  label: "Estimated Property Value",
                  placeholder: "Amount",
                  type: "currency",
                  startAdornment: "$",
                },
              },
              {},
            ],
            [
              {
                name: "appraiser_description",
                component: Textarea,
                props: {
                  label: "Description",
                },
              },
              {},
            ],
          ],
          true: [
            [
              {
                name: "appraiser_name",
                component: Input,
                props: {
                  label: "Name of Appraiser",
                },
              },
              {
                name: "appraiser_report_date",
                component: DatePicker,
                props: {
                  label: "Report Date",
                },
              },
            ],
            [
              {
                name: "appraised_residual_land_value",
                component: Input,
                props: {
                  label: "Appraised Residual Land Value",
                  placeholder: "Amount",
                  type: "currency",
                  startAdornment: "$",
                },
              },
              {
                name: "appraised_as_complete_value_of_property",
                component: Input,
                props: {
                  label: "Appraised As-Complete Value of Property",
                  placeholder: "Amount",
                  type: "currency",
                  startAdornment: "$",
                },
              },
            ],
            [
              {
                name: "total_appraised_value_of_property",
                component: Input,
                props: (form) => {
                  const defaultProps = {
                    label: "Total Appraised Value of Property",
                    disabled: true,
                    startAdornment: "$",
                    value: "0",
                  };
                  if (!form) return defaultProps;
                  const [landValue, valueOfProperty] = form.watch([
                    "appraised_residual_land_value",
                    "appraised_as_complete_value_of_property",
                  ]);
                  let value = 0;
                  if (
                    landValue !== null &&
                    typeof landValue !== "undefined" &&
                    String(landValue).length > 0
                  )
                    value += parseFloat(landValue);

                  if (
                    valueOfProperty !== null &&
                    typeof valueOfProperty !== "undefined" &&
                    String(valueOfProperty).length > 0
                  )
                    value += parseFloat(valueOfProperty);

                  return {
                    ...defaultProps,
                    value: currencyStyle(String(value.toFixed(2))),
                  };
                },
              },
              {
                name: "appraised_cost_to_complete",
                component: Input,
                props: {
                  label: "Appraised Cost-To-Complete",
                  placeholder: "Amount",
                  type: "currency",
                  startAdornment: "$",
                },
              },
            ],
            [
              {
                name: "appraiser_description",
                component: Textarea,
                props: {
                  label: "Description",
                },
              },
              {
                name: "appraiser_report_filename",
                component: FilePicker,
                props: {
                  label: "Appraisal Report",
                  type: "file",
                },
              },
            ],
          ],
        },
      },
    },
  ],
];

const existingProperty = [
  [
    {
      name: "third_party_appraisal",
      component: RadioGroupList,
      props: {
        list: appraisalThirdPartyAvailable,
        label: "Third Party Appraisal Availability",
      },
    },
    {},
  ],
  [
    {
      renderAsFormItem: false,
      component: ConditionalFormRenderer,
      props: {
        conditionFieldName: "third_party_appraisal",
        cacheable: true,
        getDefaultValues: () => ({
          appraised_as_complete_value_of_property: "",
          appraised_cost_to_complete: "",
          appraised_residual_land_value: "",
          appraised_value_of_property: "",
          appraiser_description: "",
          appraiser_name: "",
          appraiser_report_date: null,
          appraiser_report_filename: null,
          estimated_value_of_property: "",
          total_appraised_value_of_property: "",
        }),
        conditionalFields: {
          false: [
            [
              {
                name: "estimated_value_of_property",
                component: Input,
                props: {
                  label: "Estimated Property Value",
                  placeholder: "Amount",
                  type: "currency",
                  startAdornment: "$",
                },
              },
              {},
            ],
            [
              {
                name: "appraiser_description",
                component: Textarea,
                props: {
                  label: "Description",
                },
              },
              {},
            ],
          ],
          true: [
            [
              {
                name: "appraiser_name",
                component: Input,
                props: {
                  label: "Name of Appraiser",
                },
              },
              {
                name: "appraiser_report_date",
                component: DatePicker,
                props: {
                  label: "Report Date",
                },
              },
            ],
            [
              {
                name: "appraised_residual_land_value",
                component: Input,
                props: {
                  label: "Appraised Residual Land Value",
                  placeholder: "Amount",
                  type: "currency",
                  startAdornment: "$",
                },
              },
              {
                name: "appraised_value_of_property",
                component: Input,
                props: {
                  label: "Appraised Value of Property",
                  placeholder: "Amount",
                  type: "currency",
                  startAdornment: "$",
                },
              },
            ],
            [
              {
                name: "total_appraised_value_of_property",
                component: Input,
                props: (form) => {
                  const defaultProps = {
                    label: "Total Appraised Value of Property",
                    disabled: true,
                    startAdornment: "$",
                    value: "0",
                  };

                  if (!form) return defaultProps;
                  let value = 0;
                  const [landValue, valueOfProperty] = form.watch([
                    "appraised_residual_land_value",
                    "appraised_value_of_property",
                  ]);
                  if (
                    landValue !== null &&
                    (typeof landValue !== "undefined") &
                      (String(landValue).length > 0)
                  )
                    value += parseFloat(landValue);

                  if (
                    valueOfProperty !== null &&
                    typeof valueOfProperty !== "undefined" &&
                    String(valueOfProperty).length > 0
                  )
                    value += parseFloat(valueOfProperty);

                  return {
                    ...defaultProps,
                    value: currencyStyle(String(value.toFixed(2))),
                  };
                },
              },
              {},
            ],
            [
              {
                name: "appraiser_description",
                component: Textarea,
                props: {
                  label: "Description",
                },
              },
              {
                name: "appraiser_report_filename",
                component: FilePicker,
                props: {
                  label: "Appraisal Report",
                  type: "file",
                },
              },
            ],
          ],
        },
      },
    },
  ],
];

export const AppraisalFormFields = {
  construction: constructionFields,
  "existing property": existingProperty,
};
